import { render, staticRenderFns } from "./ContractorProjectNew.vue?vue&type=template&id=45ec66a7&scoped=true"
import script from "./ContractorProjectNew.vue?vue&type=script&lang=ts"
export * from "./ContractorProjectNew.vue?vue&type=script&lang=ts"
import style0 from "./ContractorProjectNew.vue?vue&type=style&index=0&id=45ec66a7&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ec66a7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45ec66a7')) {
      api.createRecord('45ec66a7', component.options)
    } else {
      api.reload('45ec66a7', component.options)
    }
    module.hot.accept("./ContractorProjectNew.vue?vue&type=template&id=45ec66a7&scoped=true", function () {
      api.rerender('45ec66a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/contractors/ContractorProjectNew.vue"
export default component.exports